import { ReadonlyURLSearchParams } from 'next/navigation'
import { DeployTypes } from '../emun/DeployTypes'
import { lkHosts } from '../config/hosts/lkHosts'
import { ILogonQueryParams, Languages } from '../interfaces/common'

const queryParamsKeys = [
  'appid',
  'appId',
  'form',
  'reglink',
  'returnurl',
  'callbackurl',
  'redirectUrl',
  'p',
  'login',
  'lang',
  'userEmail',
  'hide_social_buttons',
  'finish',
  'mode',
]

export function getLkUrl(relativeUrl: string, deployEnv: DeployTypes, locale: Languages): string {
  const lkHost = lkHosts[deployEnv][locale]

  return `${lkHost}${relativeUrl}`
}

export function getCallbackUrl(queryParams: ILogonQueryParams) {
  const urlSearchParams = new URLSearchParams(queryParams.reglink)
  const callbackUrlProperty = urlSearchParams.get('callbackUrl')
  const callbackurlProperty = urlSearchParams.get('callbackurl')

  return queryParams.callbackUrl || callbackUrlProperty || callbackurlProperty || ''
}

export function addQueryParamsToCallbackUrl(url: string, queryParams: ILogonQueryParams): string {
  const urlObject = new URL(url)

  queryParamsKeys.forEach((key: string) => {
    if (queryParams[key]) {
      urlObject.searchParams.set(key, String(queryParams[key]))
    }
  })

  return urlObject.href
}

export const getIsShowSocialAuth = (queryParams: ReadonlyURLSearchParams | null): boolean => {
  const hideSocialButtons: string = queryParams?.get('hide_social_buttons') ?? ''
  const showSocialAuth = hideSocialButtons !== '1'

  return showSocialAuth
}

export function isThereQueryParam(key: string, queryParams: ILogonQueryParams) {
  return queryParams[key] !== undefined && queryParams[key] !== null && queryParams[key] !== 'null'
}

export function addQueryParamsToPath(sourceUrl: string, queryParams: ILogonQueryParams): string {
  const searchParams = new URLSearchParams()

  Object.keys(queryParams).forEach((key) => {
    if (isThereQueryParam(key, queryParams)) {
      searchParams.append(key, queryParams[key])
    }
  })

  const searchParamsString = searchParams.toString()

  return sourceUrl + (searchParamsString ? `?${searchParamsString}` : '')
}
